import * as moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import ReactToPrint from "react-to-print";
import { Button } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Col,
  Icon,
  Row
} from "../../components/Component";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import { GET } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import { useHistory, useLocation } from "react-router-dom";
import Table from "../../components/react-table/Table";
import { getToken } from "../../helper/auth";
const ReportAllMortgageContract = () => {
  const printRef = useRef();
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [smOption, setSmOption] = useState(false);
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});

  const [updatedAt, setUpdatedAt] = useState();
  const [rangeDate, setRangeDate] = useState({
    start: searchParams.get('start') ? moment(searchParams.get('start')).startOf('days').toDate() : moment().startOf("months").toDate(),
    end: searchParams.get('end') ? moment(searchParams.get('end')).endOf('days').toDate() : moment().endOf('days').toDate(),
  });


  const onRangeChange = (dates) => {
    const [start, end] = dates;
    setRangeDate({
      start: start ? moment(start)?.startOf("days").toDate() : start,
      end: end ? moment(end)?.endOf("days").toDate() : end,
    });
    if (start && end) {
      setUpdatedAt(moment().valueOf());
    }
  };

  useEffect(() => {
    const newParams = new URLSearchParams({
      ...rangeDate,
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    const params = {
      fromDate: moment(rangeDate.start).format('YYYY-MM-DD'),
      toDate: moment(rangeDate.end).format('YYYY-MM-DD'),
    }

    GET(
      `/report/report-mortgage-contracts`,
      params,
      true
    ).then((resp) => {
      const { data } = resp;
      setData(data.rows);
      setSummary(data.summary);
    });
  }, [updatedAt]);

  const colTable = [
    {
      Header: "CTY đại diện vay",
      accessor: (item) => item.representativeName
    },
    {
      Header: "Ngân hàng",
      accessor: (item) => item.bankName
    },
    {
      Header: "Vay đầu kỳ(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.firstDebt}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,

    },
    {
      Header: "Lãi suất(%)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.firstDebtInterestRate}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Vay trong kỳ(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.fund}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,

    },
    {
      Header: "Lãi suất trong kỳ(%)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.fundInterestRate}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Tiền trả trong kỳ(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.payCapital}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,

    },
    {
      Header: "Lãi suất tiền trả(%)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.payCapitalInterestRate}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Tiền vay cuối kỳ(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.lastDebt}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Lãi suất cuối kỳ(%)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.lastDebtInterestRate}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Tổng lãi vay",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.interest}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
  ];

  const exportExcel = () => {
    const params = new URLSearchParams({
      fromDate: moment(rangeDate.start).format("YYYY-MM-DD"),
      toDate: moment(rangeDate.end).format("YYYY-MM-DD"),
      token: getToken(),

    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/report/report-mortgage-contracts-excel?${params.toString()}`;
    window.open(url, '_blank')
  };

  return (
    <React.Fragment>
      <Head title="BÁO CÁO KHOẢN VAY CTY"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>BÁO CÁO KHOẢN VAY CTY</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap" style={{ width: 150 }}>
                        <DatePicker
                          selected={rangeDate.start}
                          startDate={rangeDate.start}
                          onChange={onRangeChange}
                          endDate={rangeDate.end}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>
                    <li>
                      <div className="d-inline-block mr-3">
                        <ReactToPrint
                          trigger={() => <Button>In</Button>}
                          content={() => printRef.current}
                          pageStyle={``}
                        />
                        <Button onClick={exportExcel} className="ml-3">
                          Xuất excel
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div
            id="DataTables_Table_1_wrapper"
            className="dataTables_wrapper dt-bootstrap4 no-footer bg-white"
          >
            <div className="row justify-between g-2">
              <div className="col-8 col-sm-6 text-start"></div>
              <div className="col-5 col-sm-6 text-end">
                <div className="datatable-filter">
                  <div className="d-flex justify-content-end g-2">
                    <div
                      className="dataTables_length"
                      id="DataTables_Table_1_length"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="my-3">
              <Row>
                <Col md={12}>
                  <div ref={printRef}>
                    <Table
                      conditionHighlightRow={(row) => row.bankName === 'Tổng cộng' ? 'font-weight-bold bg-warning' : ''}
                      columns={colTable}
                      data={data}
                      notShowPagi={true}
                      headerRow={
                        <tr className="font-weight-bold">
                          <td colSpan={2}>Tổng(đ)</td>
                          <td className=" text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.firstDebt || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td className=" text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.firstDebtInterestRate || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td className=" text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={Math.abs(summary.fund || 0)}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td className=" text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.fundInterestRate || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td className=" text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.payCapital || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td className=" text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.payCapitalInterestRate || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td className=" text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.lastDebt || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td className=" text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.lastDebtInterestRate || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td className=" text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.interest || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                        </tr>
                      }
                    ></Table>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default ReportAllMortgageContract;
